import { Button, TextInput, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { useForgotPasswordFormContext } from '../../../contexts/forms';

import { BaseFormProps } from '../../../@types/global';

export default function ForgotPasswordForm({
  onSubmit,
  isSubmitting = false,
}: BaseFormProps) {
  const navigate = useNavigate();

  const form = useForgotPasswordFormContext();

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="lg">
        <TextInput
          label="Email"
          placeholder="your-email@domain.com"
          type="email"
          autoComplete="email"
          withAsterisk={false}
          disabled={isSubmitting}
          {...form.getInputProps('email')}
        />
        <Stack align="center">
          <Button type="submit" loading={isSubmitting} w={200}>
            Send Email
          </Button>
          <Button
            variant="subtle"
            onClick={() => navigate('/login')}
            disabled={isSubmitting}
            w={200}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </form>
  );
}
